import React, { useEffect, useState } from "react";
import "./Categories.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Common_Heading_Round_holder from "../common-components/common_Heading_Round_holder/Common_Heading_Round_holder";
import Product_card from "../common-components/product_card/Product_card";
import Green_round_btn from "../common-components/common_btn/green_round_btn/Green_round_btn";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
  getAllBrands
} from "../../features/master/masterSlice";
import {
  getAllProducts,
  getGroupByProduct,
} from "../../features/products/productsSlice";
import Product_Info_Card from "../common-components/product_info_card/Product_Info_Card";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import Category_Subcategory_Card from "../common-components/category_subcategory_card/Category_Subcategory_Card";
import { variant_type } from "../../utils/common";
import Common_heading_holder from "../common-components/common_heading_holder/Common_heading_holder";

const STEP = 4;

function Categories() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category_id");
  const dispatch = useDispatch();
  const app_setup = useSelector((state) => state.master.app_setup);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup,
  );

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Categories", link: "", isActive: true },
  ];

  const [visibleCounts, setVisibleCounts] = useState([]);

  // Scroll to a specific category section when "See Less" is clicked
  const handleToggle = (index, totalProducts, categoryId) => {
    setVisibleCounts((prevCounts) => {
      const newCounts = prevCounts.map((count, i) =>
        i === index
          ? count >= totalProducts
            ? STEP
            : Math.min(count + STEP, totalProducts)
          : count,
      );

      // Scroll if reducing to STEP
      if (prevCounts[index] >= totalProducts) {
        const el = document.getElementById(categoryId);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100); // delay to ensure layout update
        }
      }

      return newCounts;
    });
  };

  // const location = useLocation();

  const category_Id = location.state?.category_id;

  useEffect(() => {
    dispatch(getGroupByProduct());

    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location, dispatch]);

  useEffect(() => {
    dispatch(getGroupByProduct({ p_category_id: categoryId }));
  }, [dispatch, categoryId]);

  useEffect(() => {
    if (categoryWiseProduct?.data) {
      setVisibleCounts(new Array(categoryWiseProduct.data.length).fill(STEP));
    }
  }, [categoryWiseProduct]);

  useEffect(() => {
    const scrollToId = location.state?.scrollToId;
    if (scrollToId) {
      const scroll = () => {
        const element = document.getElementById(scrollToId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }, [location.state]);

  const category = useSelector((state) => state.master.categories);
  const subcategories = useSelector((state) => state.master.subcategories);
  const all_products = useSelector((state) => state.product.allProducts); 

 const brands = useSelector((state) => state.master.brands);

useEffect(() => {
  dispatch(getAllBrands());
}, [dispatch]);

  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [childList, setChildList] = useState([]);
  const [childStatus, setChildStatus] = useState(""); // noChild

  const handleCategoryClick = (category_id) => {
    setStatus("");
    // dispatch(getAllSubCategory({ category_id }));
  };

  const handleSubCategoryClick = (categoryId, subId) => {
    setSelectedCategoryId(categoryId);
    setSelectedSubCategory(subId);

    // Find the clicked subcategory
    const selected = subcategories.find((s) => s.id === subId);

    // Populate child list
    if (!selected || !selected.children || selected.children.length === 0) {
      setChildList([]);
      setChildStatus("noChild");
    } else {
      setChildList(selected.children);
      setChildStatus("");
    }

    // Load products
    dispatch(
      getAllProducts({
        category_id: categoryId,
        // subcategory_id: subId,
      }),
    );
  };

  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const [selectedBrand, setSelectedBrand] = useState("");

  useEffect(() => {
    if (!category || category.length === 0) {
      setStatus("noCategory");
      return;
    }

    setStatus("");

    if (categoryId) {
      setSelectedCategoryId(categoryId);
    }
  }, [category]);

  useEffect(() => {
    if (status === "noCategory") return;

    // if (!subcategories || subcategories.length === 0) {
    //   setStatus("noSubcategory");
    //   return;
    // }

    setStatus("");
    dispatch(
      getAllProducts({
        category_id: selectedCategoryId || categoryId,
        // subcategory_id: subcategories?.[0]?.id,
        brand_id: selectedBrand,
      }),
    );
  }, [selectedCategoryId, selectedBrand, categoryId]);

  useEffect(() => {
    if (status === "noCategory" || status === "noSubcategory") return;

    if (!all_products?.data || all_products.data.length === 0) {
      setStatus("noProducts");
      return;
    }

    setStatus("");
  }, [all_products]);


  // useEffect(() => {
  //   if (category.length > 0 && subcategories?.length > 0) {
  //     dispatch(
  //       getAllProducts({
  //         category_id: category?.[0].id,
  //         subcategory_id: subcategories?.[0].id,
  //       })
  //     );
  //   }
  // }, [category, subcategories]);

  const [status, setStatus] = useState("");

  return (
    <section className="Categories_section_holder">
      <div className="container-fluid">
        <div className="Categories">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />

          {/* new code for subcategories */}

          <Common_heading_holder
            heading_text={
              <>
                <span className="black-text">Explore </span>
                <br />
                <span className="blue-text">Collection</span>
              </>
            }
          />

          <div className="cat_subcat_div">
            {status === "noCategory" ? (
              <p className="text-danger">No category available.</p>
            ) : (
              <div variant="pills" className="flex-row p-0 mb-3">
                <Swiper
                  className="mySwiper "
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  breakpoints={{
                    0: { slidesPerView: 3, spaceBetween: 10 },
                    350: { slidesPerView: 4, spaceBetween: 10 },
                    576: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 5, spaceBetween: 10 },
                    992: { slidesPerView: 6, spaceBetween: 10 },
                    1200: { slidesPerView: 8, spaceBetween: 10 },
                  }}
                >
                  <SwiperSlide key={0} className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        eventKey=""
                        onClick={() => {
                          setSelectedCategoryId("");

                          // Clear category_Id by resetting state
                          navigate(location.pathname, {
                            replace: true,
                            state: {},
                          });
                        }}
                      >
                        <Category_Subcategory_Card
                          activeClassName={
                            selectedCategoryId === "" ? "activecategory" : ""
                          }
                          // activeClassName={
                          //   category_Id
                          //     ? Number(category_Id) === Number(slide?.id)
                          //       ? "activecategory"
                          //       : ""
                          //     : selectedCategoryId === slide?.id
                          //     ? "activecategory"
                          //     : ""
                          // }
                          className="product-image"
                          content="All Product"
                          image={
                            process.env.REACT_APP_IMG_URL + app_setup?.qr_image
                          }
                          imgClassName="category-image"
                        />
                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                  {category?.map((slide, index) => (
                    <SwiperSlide key={index} className="product-slide">
                      <Nav.Item>
                        <Nav.Link
                          eventKey={slide?.id}
                          onClick={() => {
                            setSelectedCategoryId(slide?.id);
                            setSelectedBrand(""); // IMPORTANT

                            // Clear category_Id by resetting state
                            navigate(location.pathname, {
                              replace: true,
                              state: {},
                            });

                            handleCategoryClick(slide?.id);
                          }}
                        >
                          <Category_Subcategory_Card
                            activeClassName={
                              Number(selectedCategoryId) === Number(slide?.id)
                                ? "activecategory"
                                : ""
                            }
                            // activeClassName={
                            //   category_Id
                            //     ? Number(category_Id) === Number(slide?.id)
                            //       ? "activecategory"
                            //       : ""
                            //     : selectedCategoryId === slide?.id
                            //     ? "activecategory"
                            //     : ""
                            // }
                            className="product-image"
                            content={slide?.name}
                            image={process.env.REACT_APP_IMG_URL + slide?.image}
                            imgClassName="category-image"
                          />
                          <div className="triangle-right"></div>
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            )}
          </div>

          {/* Brands Filter */}
          {brands?.length > 0 && (
            <div className="cat_subcat_div mt-3">
              <Swiper
                className="mySwiper"
                pagination={{
                  dynamicBullets: true,
                  clickable: true,
                }}
                modules={[Pagination]}
                breakpoints={{
                  0: { slidesPerView: 3, spaceBetween: 10 },
                  576: { slidesPerView: 4, spaceBetween: 10 },
                  768: { slidesPerView: 5, spaceBetween: 10 },
                  992: { slidesPerView: 6, spaceBetween: 10 },
                }}
              >
                {/* All Brands */}
                <SwiperSlide key={0} className="product-slide">
                  <Nav.Item>
                    <Nav.Link
                      onClick={() => {
                        setSelectedBrand("");
                        // dispatch(
                        //   getAllProducts({
                        //     category_id: selectedCategoryId || categoryId,
                        //   }),
                        // );
                      }}
                      
                    >
                      <Category_Subcategory_Card
                        activeClassName={
                          selectedBrand === "" ? "activecategory" : ""
                        }
                        className="product-image"
                        content="All Brands"
                        image={
                          process.env.REACT_APP_IMG_URL + app_setup?.qr_image
                        }
                        imgClassName="category-image"
                      />
                      <div className="triangle-right"></div>
                    </Nav.Link>
                  </Nav.Item>
                </SwiperSlide>

                {/* Dynamic Brands */}
                {brands?.map((brand, index) => (
                  <SwiperSlide key={index} className="product-slide">
                    <Nav.Item>
                      <Nav.Link
                        onClick={() => {
                          setSelectedBrand(brand.id);

                          // dispatch(
                          //   getAllProducts({
                          //     category_id: selectedCategoryId || categoryId,
                          //     brand_id: brand.id,
                          //   }),
                          // );
                        }}
                      >
                        <Category_Subcategory_Card
                          activeClassName={
                            selectedBrand === brand.id ? "activecategory" : ""
                          }
                          className="product-image"
                          content={brand?.name}
                          image={process.env.REACT_APP_IMG_URL + brand?.image}
                          imgClassName="category-image"
                        />
                        <div className="triangle-right"></div>
                      </Nav.Link>
                    </Nav.Item>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}

          {/* {status === "noCategory" ? null : status === "noSubcategory" ? (
            <p className="text-danger">
              No subcategory available for this category.
            </p>
          ) : (
            <>
              <div className="">
                <div className="heading_holder">
                  <h4 className="heading_text">Sub Category</h4>
                </div>
                <div variant="pills" className="flex-row p-0  mb-3">
                  <Swiper
                    className="mySwiper"
                    onSwiper={(swiper) => setSwiperInstance(swiper)}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    modules={[Pagination, Navigation]}
                    breakpoints={{
                      0: { slidesPerView: 2, spaceBetween: 10 },
                      420: { slidesPerView: 3, spaceBetween: 10 },
                      486: { slidesPerView: 3, spaceBetween: 10 },
                      576: { slidesPerView: 4, spaceBetween: 10 },
                      768: { slidesPerView: 5, spaceBetween: 10 },
                      992: { slidesPerView: 6, spaceBetween: 10 },
                      1200: { slidesPerView: 8, spaceBetween: 10 },
                    }}
                  >
                    {Array.isArray(subcategories) &&
                      subcategories.map((slide, index) => (
                        <SwiperSlide key={index} className="product-slide">
                          <Nav.Item>
                            <Nav.Link
                              eventKey={slide?.id}
                              onClick={() =>
                                handleSubCategoryClick(
                                  slide?.p_category_id,
                                  slide?.id,
                                )
                              }
                            >
                              <Category_Subcategory_Card
                                className="product-image"
                                content={slide?.name}
                                image={
                                  process.env.REACT_APP_IMG_URL + slide?.image
                                }
                                imgClassName="category-image"
                              />
                              <div className="triangle-right"></div>
                            </Nav.Link>
                          </Nav.Item>
                        </SwiperSlide>
                      ))}
                  </Swiper>
                </div>
              </div>
            </>
          )} */}

          {/* {childStatus === "noChild" ? (
            <p className="text-danger">No child category available.</p>
          ) : (
            childList.length > 0 && (
              <>
                <div className="heading_holder">
                  <h4 className="heading_text">Child Categories</h4>
                </div>

                <Swiper
                  className="mySwiper"
                  pagination={{ dynamicBullets: true, clickable: true }}
                  modules={[Pagination]}
                  breakpoints={{
                    0: { slidesPerView: 2, spaceBetween: 10 },
                    576: { slidesPerView: 3, spaceBetween: 10 },
                    992: { slidesPerView: 4, spaceBetween: 10 },
                  }}
                >
                  {childList.map((child, i) => (
                    <SwiperSlide key={i}>
                      <Nav.Item>
                        <Nav.Link
                          onClick={() => navigate(`/shop?childId=${child.id}`)}
                        >
                          <Category_Subcategory_Card
                            content={child.name}
                            image={process.env.REACT_APP_IMG_URL + child.image}
                          />
                        </Nav.Link>
                      </Nav.Item>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </>
            )
          )} */}

          {status === "noCategory" ||
          status === "noSubcategory" ? null : status === "noProducts" ? (
            <p className="text-danger">
              No products available for this selection.
            </p>
          ) : (
            <>
              <Common_heading_holder
                heading_text={
                  <>
                    <span className="black-text">Discover </span>
                    <br />
                    <span className="blue-text">Products</span>
                  </>
                }
              />

              <div className="row">
                {all_products?.data?.map((product, index) => {
                  let metal;
                  let size;
                  let triple;
                  if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Single)
                  ) {
                    metal = product?.Product_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Double)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                  } else if (
                    Number(product?.variant_type_id) ===
                    Number(variant_type.Triple)
                  ) {
                    metal = product?.Product_Variants?.[0];
                    size = metal?.Double_Variants?.[0];
                    triple = size?.Triple_Variants?.[0];
                  }

                  const activeVariant = triple || size || metal;

                  return (
                    <div
                      className="col-lg-4 col-md-4 col-sm-6 col-6 px-md-2 px-1 custom_5_col"
                      key={product?.id || index}
                    >
                      <Product_Info_Card
                        product={product}
                        id={product?.id}
                        imgSrc={process.env.REACT_APP_IMG_URL + product?.image}
                        vdoSrc={process.env.REACT_APP_IMG_URL + product?.video}
                        productName={product?.name}
                        mrp={activeVariant?.mrp || 0}
                        priceText={activeVariant?.price || 0}
                        kgText={activeVariant?.name}
                        savingPrice={
                          parseFloat(activeVariant?.mrp || 2) -
                          parseFloat(activeVariant?.price || 2)
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {/* category_wise_product */}
          {/* <div className="all_cats_div">
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <h4 className="heading_text">{category.name}</h4>
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-4 col-md-4 col-sm-6 col-6  px-md-2 px-1 custom_5_col"
                          key={idx}
                        >
                          <Product_Info_Card
                            product={product}
                            id={product.id}
                            imgSrc={
                              process.env.REACT_APP_IMG_URL + product.image
                            }
                              vdoSrc={process.env.REACT_APP_IMG_URL + product.video}
                            productName={product.name}
                            priceText={product.Product_Variants[0]?.price}
                            mrp={product.Product_Variants[0]?.mrp}
                            kgText={product.Product_Variants[0]?.name}
                            savingPrice={
                              parseFloat(
                                product.Product_Variants[0]?.mrp || 0
                              ) -
                              parseFloat(
                                product.Product_Variants[0]?.price || 0
                              )
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </div> */}

          {/* old code */}
          {/* <>
            {categoryWiseProduct?.data?.length > 0 ? (
              categoryWiseProduct.data.map((category, index) => (
                <div className="Categories_holder" key={index}>
                  <div id={category.id}>
                    <Common_Heading_Round_holder headingText={category.name} />
                    <div className="row">
                      {category?.Products?.slice(
                        0,
                        visibleCounts[index] || STEP
                      ).map((product, idx) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-6  px-md-2 px-1"
                          key={idx}
                        >
                          <Product_card
                            product={product}
                            savingPrice={
                              parseFloat(product.Product_Variants[0]?.mrp) -
                              parseFloat(product.Product_Variants[0]?.price)
                            }
                          />
                        </div>
                      ))}
                    </div>

                    {category?.Products?.length > STEP && (
                      <div className="see_more_btn_holder">
                        <Green_round_btn
                          btnText={
                            visibleCounts[index] >= category.Products.length
                              ? "See Less"
                              : "See More"
                          }
                          onClick={() =>
                            handleToggle(
                              index,
                              category.Products.length,
                              category.id
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="no_product_available_holder">
                <h3>No Category Available</h3>
              </div>
            )}
          </> */}
        </div>

        {/* <Stay_Connected /> */}
      </div>
    </section>
  );
}

export default Categories;
